import React, { memo } from 'react'

import DayPickerInput from 'react-day-picker/DayPickerInput'
import { formatDate, parseDate } from 'react-day-picker/moment'

import { CalendarToday, Checkbox, classnames, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, instanceOf, oneOfType, string } from 'prop-types'

import PickerClasses from 'Pods/Shared/DatePickClassNames'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const DATE_FORMAT = 'YYYY-MM-DD'

function DeadlineField({ deadline, isEndless, onDayChange, onEndlessChange, errorText }) {
  const t = useTranslation()

  return (
    <div className="deadline-field">
      <span className="deadline-field__label cgt-body-base-semibold">
        {t('viewerSidebar.enhance.assist.deadline.label')}
        <b className="cgt-legacy-color-utility-danger-100"> *</b>
      </span>

      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label
        className={classnames(
          'deadline-field__control',
          !!errorText && 'deadline-field__control--error',
          isEndless && 'deadline-field__control--disabled',
        )}
        htmlFor="assist-deadline"
      >
        <Icon
          svgComponent={CalendarToday}
          size="small"
          color="dark"
          className="deadline-field__icon"
          disabled={isEndless}
        />

        <DayPickerInput
          classNames={PickerClasses.PickerInput}
          dayPickerProps={{
            classNames: PickerClasses.DatePickerClasses,
            disabledDays: { before: new Date() },
          }}
          format={DATE_FORMAT}
          placeholder={DATE_FORMAT}
          parseDate={parseDate}
          formatDate={formatDate}
          inputProps={{ id: 'assist-deadline', name: 'deadline', 'aria-label': 'Deadline', disabled: isEndless }}
          onDayChange={onDayChange}
          value={deadline}
          hideOnDayClick
        />
      </label>

      {!!errorText && (
        <span className="deadline-field__error cgt-body-base-semibold cgt-legacy-color-utility-danger-100">
          {errorText}
        </span>
      )}

      <Checkbox
        id="assist-endless"
        name="isEndless"
        size="medium"
        checkedColor="primary"
        isControlled
        isChecked={isEndless}
        onChange={onEndlessChange}
        label={t('viewerSidebar.enhance.assist.deadline.noFixed')}
        className="deadline-field__checkbox"
      />
    </div>
  )
}

DeadlineField.propTypes = {
  deadline: oneOfType([string, instanceOf(Date)]).isRequired,
  isEndless: bool.isRequired,
  onDayChange: func.isRequired,
  onEndlessChange: func.isRequired,
  errorText: string.isRequired,
}

export default memo(DeadlineField)
